import { put, select, takeEvery, call, delay } from 'redux-saga/effects'
import { get, isEmpty } from 'lodash'
import { toast } from 'react-toastify'


import {
  addToUnsyncedOrderList,
  saveOrder,
  START_OFFLINE_CARD_ORDER,
  START_ONLINE_CARD_ORDER,
  syncOrderInitiated,
  syncOrderRequested,
} from '../../actions/order'
import { customHistory } from '../../stores'
import { SIGNATURE_THRESHOLD_AMOUNT } from '../../constants'
import { createOrder } from '../../models/order/create'
import { getIsSuitesOrTabsMode } from '../../selectors/config'
import { makeGetCartItems } from '../../selectors/cart'
import { ORDER_STATES } from '../../utils/orderStates'
import { getUserNameFromCard, makeUserAttributes } from '../../utils/orderUtils'
import { closeTabWithStoredCard } from './tabOrder'


function* createCardOrderWithArgs(args = {}) {
  const order = yield createOrder(args)
  if (order.remoteOrderTotal.failed) {
    toast.error("Order Creation Failed")
    return
  }
  const { amountInCents, uuid } = order

  yield put(saveOrder(order))
  yield handleSyncAndRedirect(uuid, args?.isNoTipMenu, args?.signatureRequired)
}

function* handleSyncAndRedirect(orderUuid, isNoTipMenu, signatureRequired) {
  yield put(addToUnsyncedOrderList(orderUuid))
  yield put(syncOrderInitiated(orderUuid))
  yield put(syncOrderRequested(orderUuid))

  if (isNoTipMenu && !signatureRequired) {
    yield delay(1000)
    yield call(closeTabWithStoredCard, { payload: {
      orderId: orderUuid
    }})
  }
}

const sharedCardOrderArgs = (params = {}) => {
  const cardReaderData = get(params, 'payload.cardReaderData', {})

  return {
    cardReaderData,
    exemptionOverrides: get(params, 'payload.exemptionOverrides'),
    lineItems: get(params, 'payload.lineItems'),
    orderNumber: get(cardReaderData, 'orderNumber'),
    paymentType: 'freedompay_credit',
    userAttributes: makeUserAttributes(cardReaderData),
    userName: getUserNameFromCard(cardReaderData),
    uuid: get(cardReaderData, 'uuid'),
    userNotes: params?.payload?.userNotes ?? null,
    options: params?.payload?.options ?? { useAuthedAmountInCents: false },
  }
}

const directTo = (method = 'push', path) => {
  if (path === undefined) return

  customHistory[method](path)
}

export function* startOnlineCardOrder(params = {}) {
  const getCartItems = makeGetCartItems()
  const lineItems = yield select(getCartItems)
  const args = {
    ...sharedCardOrderArgs(params),
    paymentCompleted: true,
    state: get(params, 'payload.state'),
    isNoTipMenu: params?.payload?.isNoTipMenu,
    signatureRequired: params?.payload?.signatureRequired,
  }
  if (isEmpty(lineItems)) {
    yield call(directTo, 'push', '/tab-order')
    toast.error("Orders must have at least one associated item")
    return
  }
  yield createCardOrderWithArgs(args)
}

export function* watchStartOnlineCardOrder() {
  yield takeEvery(START_ONLINE_CARD_ORDER, startOnlineCardOrder)
}


export function* startOfflineCardOrder(params = {}) {
  const args = {
    ...sharedCardOrderArgs(params),
    paymentCompleted: false,
    state: ORDER_STATES['APPROVED_OFFLINE'],
  }

  yield createCardOrderWithArgs(args)
}

export function* watchStartOfflineCardOrder() {
  yield takeEvery(START_OFFLINE_CARD_ORDER, startOfflineCardOrder)
}
